import * as React from 'react';

interface IAccordionHeaderProps extends React.PropsWithChildren {
	collapsible?: boolean;
	startCollapsed?: boolean;
	noTopPadding?: boolean;
	subheading?: string;
	headingSize?: 'small' | 'standard';
	icon?: () => JSX.Element;
	topRule?: boolean;
	breakpoint?: string;
}

export const AccordionHeader: React.FC<IAccordionHeaderProps> = ({
	children,
	collapsible,
	startCollapsed,
	noTopPadding,
	subheading,
	headingSize,
	icon,
	topRule,
	breakpoint }) => {

	const containerRef = React.createRef<HTMLDivElement>();

	// On first render, check if startCollapsed true, if so toggle collapse (we start by default not collapsed)
	React.useEffect(() => {
		if (startCollapsed) {
			toggleCollapse(containerRef.current);
		}
	}, []);

	const toggleCollapse = (e: any) => {
		if (collapsible) {
			const sibling = e.nextSibling;
			const child = e.firstChild;
			if (sibling.hidden) {
				child.classList.remove('accordion__header--collapsed');
				sibling.hidden = false;
			} else {
				child.classList.add('accordion__header--collapsed');
				sibling.hidden = true;
			}
		}
	};

	const clicked = (e: any) => {
		toggleCollapse(e.currentTarget);
	};

	const innerClasses = ['accordion__header-inner'];
	if (noTopPadding) {
		innerClasses.push('accordion__header-no-padding');
	}

	if (collapsible) {
		innerClasses.push('accordion__header--clickable');
	}

	const outerClasses = ['accordion__header'];
	if (topRule) {
		outerClasses.push('accordion__header-top-rule');
	}

	const headingClass = headingSize === 'small' ? 'accordion__header-text-sm' : 'accordion__header-text';
	const subheadingClass = headingSize === 'small' ? 'accordion__sub-text-sm' : 'accordion__sub-text';

	const subheadingElem = <>
		<div className="accordion__header-subheading accordion__header-text-container">
			<span className={subheadingClass}>{subheading}</span>
		</div>
	</>;

	return <div ref={containerRef} onClick={clicked} className={outerClasses.join(' ')}>
		<div className={innerClasses.join(' ')} >
			{icon && icon()}
			<div className="accordion__header-text-container">
				<span className={headingClass}>{children}</span>
				{subheading && breakpoint === 'desktop' && subheadingElem}
			</div>
		</div>
		{subheading && breakpoint !== 'desktop' && subheadingElem}
	</div>;
};
